<template>
  <v-layout>
    <v-flex>
      <div
        v-if="clientBusiness.locations && clientBusiness.locations.length == 1"
      >
        <ApiField
          fieldType="autocomplete"
          :items="possibleManagers"
          itemText="name"
          itemValue="id"
          storeAction="clientBusinesses/locationUpdate"
          storeUpdate="clientBusinesses/refreshLocation"
          paramName="worksite"
          :object="clientBusiness.locations[0]"
          fieldName="manager_id"
          :storeFieldValue="clientBusiness.locations[0].managerId"
          label="Manager"
        >
        </ApiField>
      </div>
      <div v-else>
        <h2 class="headline">Managers:</h2>
        <div v-for="location in clientBusiness.locations">
          <li v-if="location.managerId">
            {{ location.managerName }} ({{ location.name }})
          </li>
        </div>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from "vuex";
import collectionsApi from "@/api/collections";
import ApiField from "@/components/base/api-field.vue";

export default {
  props: ["clientBusiness"],
  components: {
    ApiField
  },
  computed: {
    ...mapState("userAuth", ["user"]),
    exampleComputed: function() {
      return this.example;
    }
  },
  created() {
    this.setUp();
  },
  watch: {},
  data: function() {
    return {
      possibleManagers: [],
      newManager: null
    };
  },
  methods: {
    setUp() {
      collectionsApi.getManagersList({}, managers => {
        this.possibleManagers = managers;
      });
    },
    updateManager() {
      if (!this.newManager) {
        return;
      }
      this.$store.dispatch("clientBusinesses/locationUpdate", {
        id: this.clientBusiness.locations[0].id,
        worksite: {
          manager_id: this.newManager.id
        }
      });
    }
  }
};
</script>

<style scoped></style>
